<template>
	<div class="container">
		<div class="container_bg"></div>
		<!-- 推广链接中间页 -->
	</div>
</template>

<script>
	import {Toast, MessageBox } from "mint-ui";
	export default {
		data(){
			return{
				promotionCode:'',
				isReturn:false,
				recentlyRead:''
			}
		},
		mounted() {
			if(this.$route.query.recentlyRead){
				this.recentlyRead = this.$route.query.recentlyRead;
			}
			var openid =  this.$base.getStorage('openid')
			if (!openid) { //静默登录手动登录
				// #ifdef H5
				// #endif
			} else{
				this.getGoReadingBook();
				
			}
		},
		methods:{
			getGoReadingBook(){
				if(this.recentlyRead){//获取继续阅读第二本第三本书
					var params={
						recentlyRead:this.recentlyRead
					}
				   this.$api.getRecentlyReadBook(params).then(res=>{
					   if(res.status==1){
						   	this.$router.replace({
							path:'/pages/bookRead/index',
							query:{
								bookid:res.data,
								pageType:'promotionLink',
								externalLink:1
							}
						})
					   }
				   })
				}else{
					this.$api.getGoReadingBook().then(res=>{
					if (res.status == 1) {
						this.isReturn=false;
						this.$router.replace({
							path:'/pages/bookRead/index',
							query:{
								bookid:res.data, 
								pageType:'promotionLink',
								externalLink:1
							}
						})
					}
				})

				}
				
				
			}
		}
	}
</script>

<style scoped>
	.container {
		padding: 0px 16px;
	}
	.container_bg{
		width: 30px;
		height: 46px;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
		background-color: #FFFFFF;
	}
</style>



// WEBPACK FOOTER //
// src/view/promotionLink/index.vue